/**
 * What a table cell or a detail field shows when its value is missing.
 *
 * One hyphen in every app and every language, so it is a glyph and not copy.
 * `standards/no-empty-placeholder` fails the lint on a literal in its place (UI-15).
 */
export const EMPTY_VALUE = '-'
